/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export default function Footer({isPublic}) {
  return (
    <footer id="footer">
  
      <div className="footer-top">
        <div className="container">
          <div className="row">
  
            <div className="col-lg-4 col-md-6 footer-contact">
              <h3>ARA Learning Academy</h3>
              <p>
              Gautam Budh Nagar,<br />
              Greater Noida<br />
              <br />
                <strong>Phone:</strong> +91 93190 56089<br />
                <strong>Email:</strong> araeducations@gmail.com<br />
              </p>
            </div>
  
            <div className="col-lg-4 col-md-8 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li><i className="bx bx-chevron-right"></i> <a href="/">Home</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href={isPublic ?"/about" : "/abouts"}>About us</a></li>
                <li><i className="bx bx-chevron-right"></i> <a href={isPublic ? "/terms" : "/term"}>Terms and policy</a></li>
              </ul>
            </div>
  
            <div className="col-lg-4 col-md-6 footer-newsletter">
              <h4>Join Our Newsletter</h4>
              {/* <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p> */}
              <form action="" method="post">
                <input type="email" name="email" /><input type="submit" value="Subscribe" />
              </form>
            </div>
  
          </div>
        </div>
      </div>
  
      <div className="container d-md-flex py-4">
  
        <div className="mr-md-auto text-center text-md-left">
          <div className="copyright">
            &copy; Copyright <strong><span>Ara Learning</span></strong>. All Rights Reserved
          </div>
          <div className="credits">
          </div>
        </div>
        <div className="social-links text-center text-md-right pt-3 pt-md-0">
          <a href="https://www.youtube.com/channel/UCzqmBLknxpVy0UsGsdEkA7Q" className="twitter"><i className="bx bxl-youtube"></i></a>
          <a href="https://www.facebook.com/ara3educations/" className="facebook"><i className="bx bxl-facebook"></i></a>
          <a href="https://instagram.com/aralearningacademy?igshid=1bbegeo48seiq" className="instagram"><i className="bx bxl-instagram"></i></a>
          {/* <a href="#" className="google-plus"><i className="bx bxl-skype"></i></a>
          <a href="#" className="linkedin"><i className="bx bxl-linkedin"></i></a> */}
        </div>
      </div>
      {/* <!-- End Footer --> */}
    </footer>
  );
}